import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Route, Router, UrlSegment, UrlTree } from '@angular/router';
import { Session } from '../../../common/entity/entities';
import { isInsightsRoleAllowed } from '../../../common/entity/enum/roleIds.enum';

/**
 * Hard access control for the AI-Insights view (#27147). Complements the header
 * trigger + default-landing gating (which only hide the entry): this blocks
 * direct navigation to /insights for anyone not permitted by
 * {@link isInsightsRoleAllowed} (empty INSIGHTS_ROLE_IDS = all roles; non-empty =
 * only those roles). Still requires a valid session — an invalid/expired session
 * is denied and redirected to /home.
 */
@Injectable({ providedIn: 'root' })
export class InsightsAccessGuard implements CanActivate, CanLoad {
  constructor(private router: Router) {}

  private allowed(): boolean {
    return Session.valid && isInsightsRoleAllowed(Session.roleIds);
  }

  canActivate(): boolean | UrlTree {
    return this.allowed() ? true : this.router.parseUrl('/home');
  }

  canLoad(_route: Route, _segments: UrlSegment[]): boolean {
    if (this.allowed()) {
      return true;
    }
    this.router.navigate(['/home']);
    return false;
  }
}
